// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// component
import Iconify from '../../../components/iconify';

const StyledSearchbar = styled('input')(({theme}) => ({
    background: '#fff',
    border: 'none',
    boxShadow: '0 4px 8px rgb(0 0 0 / 8%)',
    borderRadius: '50px',
    padding: '10px 10px 10px 40px',
    minHeight: '48px',
    minWidth: '275px',
    fontSize: '14px',
    color: '#000',
    fontFamily: 'Poppins',
    outline: 'none',
    '::placeholder': {
    color: '#8F8F8F',

  },
    [theme.breakpoints.up('xs')]: {
        minHeight: '40px',
        minWidth: '160px',
        fontSize: '10px',
    },
    [theme.breakpoints.up('sm')]: {
        minWidth: '260px',
    },
    [theme.breakpoints.up('md')]: {
        minHeight: '48px',
        minWidth: '275px',
        fontSize: '14px',
    },

}));

// ----------------------------------------------------------------------

export default function Searchbar() {

    return (
            <Box sx={{position: 'relative'}}>
                <Iconify icon="eva:search-fill" sx={{position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#34A595'}} />
                <StyledSearchbar
                    autoFocus
                    fullWidth
                    disableUnderline
                    placeholder="Search…"
                />
            </Box>
    );
}
